import { render, staticRenderFns } from "./VideoDemoRoute.vue?vue&type=template&id=4e050107"
import script from "./VideoDemoRoute.vue?vue&type=script&lang=js"
export * from "./VideoDemoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports